var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 21,
    height: 21,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M9.1,10.4a2.6,2.6,0,1,1-2.6,2.6A2.606,2.606,0,0,1,9.1,10.4Zm0-7.8A2.606,2.606,0,0,0,6.5,5.2h5.2A2.606,2.606,0,0,0,9.1,2.6Zm6.5,18.191H2.6a2.606,2.606,0,0,1-2.6-2.6V7.8A2.606,2.606,0,0,1,2.6,5.2H3.9a5.2,5.2,0,0,1,10.4,0h1.3a2.606,2.606,0,0,1,2.6,2.6v10.4A2.606,2.606,0,0,1,15.593,20.79Z",
    transform: "translate(1.299)",
    fill: "#356ab3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.ffae632e3f10d631b701c5378598da0f.svg";
export { ForwardRef as ReactComponent };